module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec03_pc_1916a5a53ad355c96719b8959f3d0a9e.jpg";